import { HeaderInjector } from "@soenergy/header-injector"

HeaderInjector.init({
  isWidgetSticky: true,
  appendToEl: "#app-header",
  scopeKey: process.env.VUE_APP_VERCEL_GIT_COMMIT_REF ?? "local",
  defaultHeaderValue: process.env.VUE_APP_X_BRANCH_NAME,
  apiUrls: [
    process.env.VUE_APP_API_GATEWAY_URL,
    process.env.VUE_APP_API_GATEWAY_URL_V2,
  ],
})
